// Keep automatically supplied product bullets readable even when their source
// text includes its own dash or starts with a lowercase letter.
(() => {
  const bulletSelector = '.short-desc-bullets li, .compare-product__highlights li, .compare-product__source-highlights li';

  function normalizeBullet(bullet) {
    const walker = document.createTreeWalker(bullet, NodeFilter.SHOW_TEXT);
    let removeLeadingDashes = true;
    let capitalized = false;
    let node;

    while ((node = walker.nextNode()) && !capitalized) {
      // A nested list item is normalized separately.
      if (node.parentElement.closest('li') !== bullet) continue;

      let value = node.nodeValue;
      if (removeLeadingDashes) {
        value = value.replace(/^[\s\u00a0]*(?:[-\u2010-\u2015\u2212\u2022][\s\u00a0]*)+/u, '').trimStart();
        if (value) removeLeadingDashes = false;
      }

      if (!value) {
        if (node.nodeValue !== value) node.nodeValue = value;
        continue;
      }

      const firstLetter = value.search(/\p{L}/u);
      if (firstLetter !== -1) {
        value = value.slice(0, firstLetter)
          + value[firstLetter].toLocaleUpperCase()
          + value.slice(firstLetter + 1);
        capitalized = true;
      }
      if (node.nodeValue !== value) node.nodeValue = value;
    }
  }

  function normalizeBullets(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      const bullet = root.parentElement?.closest(bulletSelector);
      if (bullet) normalizeBullet(bullet);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(bulletSelector)) normalizeBullet(root);
    root.querySelectorAll(bulletSelector).forEach(normalizeBullet);
  }

  document.addEventListener('DOMContentLoaded', () => {
    normalizeBullets(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(normalizeBullets);
        if (mutation.type === 'characterData') normalizeBullets(mutation.target);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  });
})();
